import { render, staticRenderFns } from "./SaturdayRosterDay.vue?vue&type=template&id=2656957a&"
import script from "./SaturdayRosterDay.vue?vue&type=script&lang=js&"
export * from "./SaturdayRosterDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports